var _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _g4, _rect5, _g5, _rect6, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 17,
    viewBox: "0 0 87 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.6596,
    height: 16.1849,
    fill: "#00B67A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_300_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8531 6.26036H9.88826L8.35472 1.79883L6.81639 6.26036L1.85156 6.25584L5.87231 9.01602L4.33398 13.473L8.35472 10.7174L12.3707 13.473L10.8371 9.01602L14.8531 6.26036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1829 10.0266L10.8379 9.01758L8.35547 10.7189L11.1829 10.0266Z",
    fill: "#00B67A"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1699,
    width: 16.6596,
    height: 16.1849,
    fill: "#00B67A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_300_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0228 6.26036H45.058L43.5244 1.79883L41.9861 6.26036L37.0213 6.25584L41.042 9.01602L39.5037 13.473L43.5244 10.7174L47.5404 13.473L46.0068 9.01602L50.0228 6.26036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3528 10.0266L46.0077 9.01758L43.5253 10.7189L46.3528 10.0266Z",
    fill: "#00B67A"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.7557,
    width: 16.6596,
    height: 16.1849,
    fill: "#00B67A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_300_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6088 6.26036H62.6439L61.1104 1.79883L59.5721 6.26036L54.6072 6.25584L58.628 9.01602L57.0897 13.473L61.1104 10.7174L65.1263 13.473L63.5928 9.01602L67.6088 6.26036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9387 10.0266L63.5937 9.01758L61.1113 10.7189L63.9387 10.0266Z",
    fill: "#00B67A"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5859,
    width: 16.6596,
    height: 16.1849,
    fill: "#00B67A"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_300_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.439 6.26036H27.4742L25.9407 1.79883L24.4023 6.26036L19.4375 6.25584L23.4582 9.01602L21.9199 13.473L25.9407 10.7174L29.9566 13.473L28.4231 9.01602L32.439 6.26036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7687 10.0266L28.4236 9.01758L25.9412 10.7189L28.7687 10.0266Z",
    fill: "#00B67A"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52.7557,
    width: 16.6596,
    height: 16.1849,
    fill: "#00B67A"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_300_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6088 6.26036H62.6439L61.1104 1.79883L59.5721 6.26036L54.6072 6.25584L58.628 9.01602L57.0897 13.473L61.1104 10.7174L65.1263 13.473L63.5928 9.01602L67.6088 6.26036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9387 10.0266L63.5937 9.01758L61.1113 10.7189L63.9387 10.0266Z",
    fill: "#00B67A"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70.34,
    width: 16.6596,
    height: 16.1849,
    fill: "#00B67A"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_300_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.1932 6.26036H80.2284L78.6948 1.79883L77.1565 6.26036L72.1917 6.25584L76.2124 9.01602L74.6741 13.473L78.6948 10.7174L82.7108 13.473L81.1773 9.01602L85.1932 6.26036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5232 10.0266L81.1781 9.01758L78.6957 10.7189L81.5232 10.0266Z",
    fill: "#00B67A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_300_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9574,
    height: 12.5882,
    fill: "white",
    transform: "translate(1.85156 1.79883)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_300_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9574,
    height: 12.5882,
    fill: "white",
    transform: "translate(37.0215 1.79883)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_300_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9574,
    height: 12.5882,
    fill: "white",
    transform: "translate(54.6073 1.79883)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_300_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9574,
    height: 12.5882,
    fill: "white",
    transform: "translate(19.4375 1.79883)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_300_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9574,
    height: 12.5882,
    fill: "white",
    transform: "translate(54.6073 1.79883)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_300_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9574,
    height: 12.5882,
    fill: "white",
    transform: "translate(72.1916 1.79883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars5);
export default __webpack_public_path__ + "static/media/stars_5.516ab5d33d182ea5ead24608ece40762.svg";
export { ForwardRef as ReactComponent };